// extracted by mini-css-extract-plugin
export default {"whatAirlineMenuOpen":"WhatAirline_whatAirlineMenuOpen__OpExx"};